// extracted by mini-css-extract-plugin
export var active = "care-image-text-carousel-module--active--fd67a";
export var bullet = "care-image-text-carousel-module--bullet--d1ccf";
export var bullets = "care-image-text-carousel-module--bullets--96689";
export var carouselContainer = "care-image-text-carousel-module--carouselContainer--5a2d1";
export var carouselWrapper = "care-image-text-carousel-module--carouselWrapper--8c80f";
export var swiperSlide = "care-image-text-carousel-module--swiper-slide--dd910";
export var swiperWrapper = "care-image-text-carousel-module--swiper-wrapper--34ea9";